/**
 * Дата/время для API: YYYY-MM-DD или YYYY-MM-DD HH:MM:SS
 * @param {Date|string|null|undefined} value
 * @returns {string|null}
 */
export function formatApiDateTime(value) {
  if (value == null || value === '') {
    return null
  }

  if (typeof value === 'string') {
    const trimmed = value.trim()

    if (/^\d{4}-\d{2}-\d{2}$/.test(trimmed)) {
      return trimmed
    }

    const withTime = trimmed.match(
      /^(\d{4}-\d{2}-\d{2})[ T](\d{2}:\d{2}:\d{2})/
    )
    if (withTime) {
      return `${withTime[1]} ${withTime[2]}`
    }

    const localeDate = trimmed.match(/^(\d{1,2})\.(\d{1,2})\.(\d{4})$/)
    if (localeDate) {
      return `${localeDate[3]}-${localeDate[2].padStart(2, '0')}-${localeDate[1].padStart(2, '0')}`
    }

    const parsed = new Date(trimmed)
    if (!Number.isNaN(parsed.getTime())) {
      return formatDateObject(parsed)
    }

    return null
  }

  if (value instanceof Date && !Number.isNaN(value.getTime())) {
    return formatDateObject(value)
  }

  return null
}

function formatDateObject(date) {
  const ymd = `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`
  const hours = date.getHours()
  const minutes = date.getMinutes()
  const seconds = date.getSeconds()

  if (hours === 0 && minutes === 0 && seconds === 0) {
    return ymd
  }

  return `${ymd} ${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`
}
